appComum.service('produtoService', produtoService);

produtoService.$inject = ['$rootScope', '$http', 'emissorService', 'helpers', '$window'];
function produtoService($rootScope, $http, emissorService, helpers, $window) {

  /**
   * Consulta na api-web/parametrizacao a lista de produtos por emissor.
   *
   * @returns Array de produtos parametrizados
   */
  function getProdutos() {
    return new Promise((resolve, reject) => {

      // NOTE: Este é o código real acessando um endpoint fornecido pelo backend.
      // Deve ser ativado assim que o endpoint for disponibilizado para uso em produção.
      /*
      $http({
        method: "GET",
        url: `/api-web/rh/parametrizacoes/produtos/${emissorService.sigla}`,
      })
      .then(
        (response) => {
          if(response.status !== 200) {
            return reject(response);
          }

          constants.DYNAMIC_DATA.PRODUCTS = response.data;
          resolve(response.data);
        },
        (error) => {
          console.error(`getProdutos() | Error '${error.status}': ${error.data.message}`);
          reject(error);
        }
      );
      */

      // NOTE: Solução estática PALIATIVA:
        $http({
          method: "GET",
          url: `/portal/app/UI-RH/static-data/produtos.json`,
        }).then(
          (response) => {
            let data = {};

            if(response.status !== 200) {
              return reject(response);
            }

            data =  response.data[emissorService.sigla];

            // FIXME: Remover este código quando a solução foi disponibilizada (Mais na doc da função).
            getProductByEnumerationEndpoint(data);

            // TODO: Descomentar estas linhas quando o fixme acima for resolvido.
            // constants.DYNAMIC_DATA.PRODUCTS = data;
            // resolve(data);

          },
          (error) => {
            console.error(`getProdutos() | Error '${error}'`);
            reject(error);
          }
        );
    });
  }

  /**
   * Retorna uma lista de produtos disponíveis para download dos contratos.
   * TODO: Este método é um paliativo e seu retorno deve vir de alguma API.
   * Algo como $http.post('', produtos').success(data => {});
   *
   * @param {Array<Object>} produtos
   * @returns Promise com os produtos com contratos para download.
   */
  function getContratosDownload (produtos) {

    const flagAuto = produtos.find(item => item.codigoAplicacao == 28);
    const flagRefeicao = produtos.find(item => item.codigoAplicacao == 31);
    const flagBoasFestas = produtos.find(item => item.codigoAplicacao == 202);
    const flagAlimentacao = produtos.find(item => item.codigoAplicacao == 27);

    // NOTE: Estes produtos já foram informados, a única coisa que impede o tratamento é a validação do Vr Refeição e Vr Alimentação.
    // Se pudermos trabalhar com um arquivo específico para cada produto resolve o problema.''

    // NOTE: Uma sugestão é retornar todos os produtos retornados da API e retornar um array com os produtos e uma flag active:true para os matchs.

    const downloads = [{
      codigoAplicacao: '28',
      ativo: flagAuto,
      nome: 'VR Auto'
    }, {
      codigoAplicacao: '27',
      ativo: (flagAlimentacao && !flagRefeicao),
      nome: 'VR Alimentação'
    }, {
      codigoAplicacao: '31',
      ativo: (!flagAlimentacao && flagRefeicao),
      nome: 'VR Refeição'
    }, {
      codigoAplicacao: '202',
      ativo: flagBoasFestas,
      nome: 'VR Boas Festas'
    }, {
      codigoAplicacao: '27',
      ativo: (flagAlimentacao && flagRefeicao),
      nome: 'VR Refeição e VR Alimentação'
    }];

    return downloads.filter(item => item.ativo);
  }

  /**
   * Verifica a existência de um produto chamado VR Alimentação;
   * NOTE: Esta função não deve existir, validar uma forma melhor de tratar esta situação
   * obs: partials-emissor/VRPAT/pedidos/vr-boas-festas.html
   *
   * @returns Retorna true ou false;
   */
  function hasVRAlimentacao (list) {
    if(list && emissorService.sigla === "VRPAT") {
      return !!list.find(item => item.produto.nome === "VR Alimentação");
    }

    return false;
  }

  /**
   * Verifica na lista de arquivo se existe algum produto com o contrato desativado
   *
   * @returns se existe algum produto com o contrato desativado
   */
  function permiteCreditoExtra (contratoProduto) {
    if(!contratoProduto) {
      return false;
    }

    const produtos = constants.DYNAMIC_DATA.PRODUCTS;
    const produto = produtos.find(produto => produto.nome === contratoProduto.nome);

    return produto ? produto.flagPermiteCreditoExtra : false;
  }

  /**
   * Busca um produto por código na lista de produtos por emissor.
   *
   * @param {String} codigo
   * @returns Propriedades do produto
   */
  function getProdutoPorCodigo(codigo) {

    const produtos = constants.DYNAMIC_DATA.PRODUCTS;

    return produtos.find(produto => helpers.formataCodigoProduto(produto.codigoAplicacao) === helpers.formataCodigoProduto(codigo));
  }

  /**
   * Verifica se o produto informado tem um valor fixo definido
   *
   * @returns true ou false
   */
  function temValorFixo(codigo) {
    const produto = getProdutoPorCodigo(codigo);
    return produto ? produto.valorFixo != null : false;
  }


  /**
   * FIXME: Método DEPRECIADO porém necessário para garantir o funcionamento do Credenciamento.
   * Este método deve ser removido por completo quando a solução definitiva for realizada.
   *
   * Consulta os produtos no endpoint '/enumerations/{sigla_emissor}'
   */
  function getProductByEnumerationEndpoint(produtos) {

    $rootScope.getEnumerations().then((response) => {
      const _produtos = response.products;

      constants.DYNAMIC_DATA.PRODUCTS = _produtos
        ? produtos.map(produto => {
          const _produto = _produtos.find(item => helpers.formataCodigoProduto(item.id) === produto.codigoAplicacao);

          return {
            ..._produto,
            ...produto
          }
        })
        : produtos;
    });

  }

  return {
    getProdutos: getProdutos,
    getContratosDownload: getContratosDownload,
    hasVRAlimentacao: hasVRAlimentacao,
    temValorFixo: temValorFixo,
    permiteCreditoExtra: permiteCreditoExtra,
    getProdutoPorCodigo: getProdutoPorCodigo,
    produtos: () => constants.DYNAMIC_DATA.PRODUCTS,
  }
};
